import { useMutation, useQueryClient, UseMutationOptions } from '@tanstack/react-query';
import { deleteDog, type Dog } from '@/api/entities/dogs';
import { ExtractFnReturnType } from '@/lib/react-query';
import { useCognitoAuth } from '@/hooks/useCognitoAuth';
import { GraphQLRequestError } from '@/api/graphql';

type QueryFnType = typeof deleteDog;

type UseDeleteDogOptions = {
  config?: Omit<
    UseMutationOptions<ExtractFnReturnType<QueryFnType>, GraphQLRequestError, Dog>,
    'mutationFn'
  >;
};

export const useDeleteDog = ({ config }: UseDeleteDogOptions = {}) => {
  const queryClient = useQueryClient();
  const { getAccessToken } = useCognitoAuth();

  return useMutation<ExtractFnReturnType<QueryFnType>, GraphQLRequestError, Dog>({
    ...config,
    mutationFn: async (dog: Dog) => {
      return deleteDog(dog.id, getAccessToken);
    },
    onSuccess: (data, variables, onMutateResult, context) => {
      queryClient.invalidateQueries({ queryKey: ['dogs'] });
      queryClient.invalidateQueries({ queryKey: ['dogs', variables.id] });
      config?.onSuccess?.(data, variables, onMutateResult, context);
    },
  });
};
